export class ListAiAssistantSessions502Response {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "error",
            "baseName": "error",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListAiAssistantSessions502Response.attributeTypeMap;
    }
    constructor() {
    }
}
